"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var CustomizationAbstract = /*#__PURE__*/function () {
  /**
   * Pre-requisite: the variable confLocale should store an object with
   * at least the following infos:
   *   localDefaultConf.server.lang
   *   localDefaultConf.server.notes
   *   localDefaultConf.server.url_Css
   */
  function CustomizationAbstract(localDefaultConf) {
    (0, _classCallCheck2["default"])(this, CustomizationAbstract);
    this.localDefaultConf = localDefaultConf;
  }
  // [High level] Get the individual configuration
  ///
  (0, _createClass2["default"])(CustomizationAbstract, [{
    key: "getCurrencyName",
    value: function getCurrencyName() {
      return this.getServerConfig('name');
    }
  }, {
    key: "getContract1",
    value: function getContract1() {
      return this.getServerConfig('contract_1');
    }
  }, {
    key: "getContract2",
    value: function getContract2() {
      return this.getServerConfig('contract_2');
    }
  }, {
    key: "getContract3",
    value: function getContract3() {
      return this.getServerConfig('contract_3');
    }
  }, {
    key: "getHelpUrl",
    value: function getHelpUrl() {
      return this.getServerConfig('url_help');
    }
  }, {
    key: "getCondUrl",
    value: function getCondUrl() {
      return this.getServerConfig('url_cond');
    }
  }, {
    key: "getUnlockUrl",
    value: function getUnlockUrl() {
      return this.getServerConfig('url_unlock');
    }
  }, {
    key: "getHowToUrl",
    value: function getHowToUrl() {
      return this.getServerConfig('url_howto');
    }
  }, {
    key: "getWalletAddress",
    value: function getWalletAddress() {
      return this.getServerConfig('address');
    }
  }, {
    key: "getCreationMessage",
    value: function getCreationMessage() {
      return this.getServerConfig('creat_message');
    }
  }, {
    key: "getLang",
    value: function getLang() {
      var _a;
      return this.getServerConfig('lang') || ((_a = this.localDefaultConf.server) === null || _a === void 0 ? void 0 : _a.lang);
    }
  }, {
    key: "getNoteValues",
    value: function getNoteValues() {
      var _a;
      return this.getServerConfig('notes') || ((_a = this.localDefaultConf.server) === null || _a === void 0 ? void 0 : _a.notes);
    }
  }, {
    key: "hasBn",
    value: function hasBn() {
      return !!this.getNoteValues();
    }
  }, {
    key: "hasNant",
    value: function hasNant() {
      return this.getServerConfigSwitch('nant', false);
    }
  }, {
    key: "hasCM",
    value: function hasCM() {
      return this.getServerConfigSwitch('CM', false);
    }
  }, {
    key: "hasAutor",
    value: function hasAutor() {
      return this.getServerConfigSwitch('autor', false);
    }
  }, {
    key: "hasDeleg",
    value: function hasDeleg() {
      return this.getServerConfigSwitch('deleg', false);
    }
  }, {
    key: "hasPayRequest",
    value: function hasPayRequest() {
      return this.getServerConfigSwitch('payReq', false);
    }
  }, {
    key: "passwordAutocomplete",
    value: function passwordAutocomplete() {
      var number = 10000;
      try {
        if (this.cfg.server.passwordAutocomplete && this.cfg.server.passwordAutocomplete > 0) {
          number = this.cfg.server.passwordAutocomplete;
        }
      } catch (e) {}
      return number;
    }
  }, {
    key: "getCurrencies",
    value: function getCurrencies() {
      return this.getServerConfig('currencies');
    }
    // ///////////////////////////////////////////////////////////////////////////
  }, {
    key: "getServerConfig",
    value: function getServerConfig(configName) {
      try {
        return this.cfg.server[configName];
      } catch (e) {
        return '';
      }
    }
  }, {
    key: "getServerConfigSwitch",
    value: function getServerConfigSwitch(configName, defaultValue) {
      try {
        return this.cfg.server[configName].toString().toLowerCase() === 'true';
      } catch (e) {
        return defaultValue;
      }
    }
    // ///////////////////////////////////////////////////////////////////////////
  }, {
    key: "getCurrencyAssetBaseUrl",
    value: function getCurrencyAssetBaseUrl(currencyName) {
      if (!currencyName) {
        currencyName = this.cfg.server.name;
      }
      if (!this.cfg.custoRepo) {
        throw Error('Requested getCurrencyAssetBaseUrl while configuration is not available (yet?)');
      }
      return "".concat(this.cfg.custoRepo).concat(currencyName);
    }
  }, {
    key: "getCssUrl",
    value: function getCssUrl(currencyName) {
      try {
        // XXXvlab: I guess that we don't need to keep 'etherwallet' css
        // names
        return this.getCurrencyAssetBaseUrl(currencyName) + '/css/etherwallet-master.min.css';
      } catch (e) {
        console.log('`customization.getCssUrl(..)` called before configuration was ' + "ready. Returning `localDefaultConf`'s value.");
        return this.localDefaultConf.server.url_Css;
      }
    }
  }, {
    key: "getCurrencyLogoUrl",
    value: function getCurrencyLogoUrl(currencyName) {
      try {
        // XXXvlab: I guess that 'lem' stands for leman here. Shouldn't that
        // be agnostic ?
        return "".concat(this.getCurrencyAssetBaseUrl(currencyName), "/images/lem.png");
      } catch (e) {
        console.log('`customization.getCurrencyLogoUrl(..)` called before configuration ' + 'was ready. Returning empty string.');
        return '';
      }
    }
  }]);
  return CustomizationAbstract;
}();
exports["default"] = CustomizationAbstract;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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